// extracted by mini-css-extract-plugin
export var bubble = "_3d-0";
export var container = "_3d-f";
export var contrastBorder = "_3d-g";
export var greyOut = "_3d-2";
export var initialsColor0 = "_3d-3";
export var initialsColor1 = "_3d-4";
export var initialsColor10 = "_3d-d";
export var initialsColor11 = "_3d-e";
export var initialsColor2 = "_3d-5";
export var initialsColor3 = "_3d-6";
export var initialsColor4 = "_3d-7";
export var initialsColor5 = "_3d-8";
export var initialsColor6 = "_3d-9";
export var initialsColor7 = "_3d-a";
export var initialsColor8 = "_3d-b";
export var initialsColor9 = "_3d-c";
export var initialsWrapper = "_3d-1";
export var large = "_3d-l";
export var medium = "_3d-k";
export var mediumSmall = "_3d-j";
export var mediumSmallMedium = "_3d-o";
export var micro = "_3d-h";
export var small = "_3d-i";
export var tiny = "_3d-n";
export var xTiny = "_3d-m";